import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Shield } from "lucide-react";
import axios from "axios";
import { sendGA4, GA4 } from "../hooks/useAnalytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        login(res.data);

        const pending = sessionStorage.getItem("pending_checkout");
        if (pending === "premium") {
          sessionStorage.removeItem("pending_checkout");
          sessionStorage.removeItem("auth_redirect");
          try {
            const checkout = await axios.post(
              `${API}/stripe/create-checkout-session`,
              { origin_url: window.location.origin },
              { withCredentials: true }
            );
            window.location.href = checkout.data.url;
            sendGA4(GA4.CHECKOUT_STARTED, { source: "auth_callback" });
            return;
          } catch {
            navigate("/pricing", { replace: true });
            return;
          }
        }

        const redirectTo = sessionStorage.getItem("auth_redirect") || "/dashboard";
        sessionStorage.removeItem("auth_redirect");
        navigate(redirectTo, { replace: true });
      } catch {
        navigate("/auth", { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <Shield className="h-10 w-10 text-teal-600 animate-pulse" />
        <p className="text-sm text-muted-foreground font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
